import React from 'react';
import PropTypes from 'prop-types';
import { Form, RadioGroup } from 'informed';
import InputRadio from '../../elements/InputRadio';
import { Spinner, FieldSet } from '../../elements';

const EspecialidadeStep = ({
  submitting,
  loadingEspecialidades,
  sendEspecialidade,
  especialidades,
  backClick
}) => (
  <Spinner active={loadingEspecialidades}>
    <FieldSet title="Escolha sua especialidade" />
    <Form onSubmit={sendEspecialidade}>
      {especialidades.length === 0 && <p>Nenhuma especialidade encontrada.</p>}
      <RadioGroup field="onboarding">
        {especialidades.map(especialidade => {
          const especialidadeLabel = `${especialidade.course} | ${
            especialidade.specialty
          } - ${especialidade.hospital} ${especialidade.nome_supervisor ? `| ${especialidade.nome_supervisor}` : ''}`;

          return (
            <InputRadio
              disabled={submitting}
              label={especialidadeLabel}
              value={especialidade.id}
            />
          );
        })}
      </RadioGroup>
      <div className="button-group mt-3">
        <button
          disabled={submitting || especialidades.length === 0}
          className="btn btn-primary"
          type="submit"
        >
          {submitting ? 'Enviando...' : 'Enviar especialidade'}
        </button>
      </div>
    </Form>
  </Spinner>
);

EspecialidadeStep.propTypes = {
  submitting: PropTypes.bool,
  loadingEspecialidades: PropTypes.bool,
  sendEspecialidade: PropTypes.func,
  especialidades: PropTypes.func,
  backClick: PropTypes.func
};

EspecialidadeStep.defaultProps = {
  submitting: false,
  loadingEspecialidades: false,
  sendEspecialidade: () => {},
  especialidades: () => {},
  backClick: () => {}
};

export default EspecialidadeStep;
